import {
  ACTIONS,
  activity,
  AnalyticsEventWithControlName,
  eventDetailVersion
} from '@uma/react-commons/dist';
import { screenPath } from 'src/utils/constants';
import { ScreenName } from 'src/utils/enums';
import { getHPSmartPrinterOverviewUrl, URLS } from 'src/utils/urls';

export const DeviceRegisterButtonClicked: AnalyticsEventWithControlName = {
  action: ACTIONS.CONTROL_BUTTON_CLICKED,
  activity,
  screenPath,
  screenName: ScreenName.DEVICES,
  controlName: 'DeviceRegisterButton',
  controlDetail: URLS.Register,
  version: eventDetailVersion
};

export const GetSupportForDeviceNotShownButtonClicked: AnalyticsEventWithControlName =
  {
    action: ACTIONS.CONTROL_BUTTON_CLICKED,
    activity,
    screenPath,
    screenName: ScreenName.DEVICES,
    controlName: 'GetSupportForDeviceNotShownButton',
    controlDetail: URLS.DeviceSupportNotShown,
    version: eventDetailVersion
  };

export const DevicesMyPrintersButtonClicked = (
  showControlHubLabel: boolean
): AnalyticsEventWithControlName => {
  return {
    action: ACTIONS.CONTROL_BUTTON_CLICKED,
    activity,
    screenPath,
    screenName: ScreenName.DEVICES,
    controlName: showControlHubLabel
      ? 'HPControlHubDevicesMyPrintersButton'
      : 'HPSmartDevicesMyPrintersButton',
    controlDetail: getHPSmartPrinterOverviewUrl(),
    version: eventDetailVersion
  };
};

export const SeeDevicesPurchasedButtonClicked = (
  controlDetail: string
): AnalyticsEventWithControlName => {
  return {
    action: ACTIONS.CONTROL_BUTTON_CLICKED,
    activity,
    screenPath,
    controlDetail,
    screenName: ScreenName.DEVICES,
    controlName: 'SeeDevicesPurchasedButton',
    version: eventDetailVersion
  };
};
